import React, { Fragment } from 'react';
import { MdModeEditOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import CustomerInfoField from './CustomerInfoField';

const CustomerSection = ({ customer, show, setShow, accountType, isBooked = false }) => {
  const { t } = useTranslation();

  const fields = [
    { label: t('Name'), value: customer?.name },
    { label: t('Address'), value: customer?.address },
    { label: t('City'), value: customer?.city },
    { label: t('Country'), value: customer?.country },
    { label: t('Zip Code'), value: customer?.zipCode },
    { label: t('Email'), value: customer?.email },
    { label: t('Phone Number'), value: customer?.phoneNumber },
    {
      label: accountType === 1 ? t('SSN No.') : t('Org No'),
      value: accountType === 1 ? customer?.ssn : customer?.orgNo,
    },
    { label: t('Reference'), value: customer?.reference },
  ];

  return (
    <Fragment key={customer?.email}>
      <span
        variant="link"
         className="icon-edit bg-primary"
        onClick={() => {
          setShow({ ...show, show: true });
        }}
        style={{
          cursor: 'pointer',
        }}
      >
        <MdModeEditOutline />
      </span>

      {fields.map(({ label, value }, index) => (
        <CustomerInfoField key={index} label={`${label}:`} value={value} />
      ))}
    </Fragment>
  );
};

export default CustomerSection;
